import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const browserLanguageMap = {
  "en":   "en",
  "es":   "es",      // both MX and ES Spanish return "es" — defaults to MX
  "de":   "de",
  "fr":   "fr",
  "pl":   "pl",
  "pt":   "pt-BR",   // Chrome returns "pt" for Brazilian Portuguese
  "zh":   "zh",
};

const mappedBrowserLang = browserLanguageMap[navigator.language] || "en";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: sessionStorage.getItem("appLanguage") || mappedBrowserLang,
  resources: {
    en: {
      translations: require("./en/translations.json"),
    },
    es: {
      translations: require("./es/translations.json"),
    },
    "es-ES": {
      translations: require("./es-ES/translations.json"),
    },
    de: {
      translations: require("./de/translations.json"),
    },
    fr: {
      translations: require("./fr/translations.json"),
    },
    pl: {
      translations: require("./pl/translations.json"),
    },
    "pt-BR": {
      translations: require("./pt-BR/translations.json"),
    },
    zh: {
      translations: require("./zh/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  nsSeparator: false
});

i18n.languages = ["en", "es", "es-ES", "de", "fr", "pl", "pt-BR", "zh"];

export default i18n;
